export const BORDER_BOTTOM_VALUE = 1;
export const FIRST_INDEX = 0;
